import { FC } from "react";
import { Button, Stack, Typography } from "@mui/material";

interface NetworkErrorScreenProps {
	onRetry: () => void;
	maxAttempts?: number;
	currentAttempt?: number;
}

/**
 * Error screen displayed when network/server errors occur during authentication
 */
export const NetworkErrorScreen: FC<NetworkErrorScreenProps> = ({
	onRetry,
	maxAttempts = 3,
	currentAttempt = 0,
}) => {
	const attemptsRemaining = maxAttempts - currentAttempt;

	return (
		<Stack
			direction="column"
			justifyContent="center"
			alignItems="center"
			width={"100%"}
			height={"100vh"}
		>
			<Stack
				direction="column"
				justifyContent="center"
				alignItems="center"
				spacing={2}
				maxWidth={500}
			>
				<img
					className="w-[269.1px] relative object-cover"
					alt="Connection Problem"
					src="/assets/network-error.png"
					onError={(e) => {
						// Hide image if it doesn't exist
						e.currentTarget.style.display = "none";
					}}
				/>
				<Typography variant="h4" textAlign="center">
					Connection Problem
				</Typography>
				<Typography variant="body1" textAlign="center">
					We're having trouble connecting to the server. This might be a
					temporary network issue.
				</Typography>
				<Typography variant="body1" textAlign="center">
					Please check your internet connection and try again.
				</Typography>
				{attemptsRemaining > 0 && currentAttempt > 0 && (
					<Typography variant="body2" color="textSecondary" textAlign="center">
						Attempts remaining: {attemptsRemaining}
					</Typography>
				)}
				<Button
					variant="contained"
					color="primary"
					onClick={onRetry}
					disabled={attemptsRemaining === 0}
				>
					{attemptsRemaining > 0 ? "RETRY" : "MAXIMUM ATTEMPTS REACHED"}
				</Button>
				{attemptsRemaining === 0 && (
					<Typography variant="body1" textAlign="center">
						Please contact your system administrator if the problem persists.
					</Typography>
				)}
			</Stack>
		</Stack>
	);
};
